import { filtersHelper } from '@/utils';
import { candidateModel } from '@/models/api/candidate.model';

export const candidateExperienceModel = (data) => ({
    uuid: data.uuid,
    name: data.name,
    company: data.company,
    address: data.address,
    department: data.department,
    salary: data.salary,
    location: data.location,
    startDate: data.start_date,
    endDate: data.end_date,
    periodNoticeMonth: data.period_notice_month,
    reasonForLeaving: data.reason_for_leaving,
    serviceSummary: data.service_summary,
    yearsOfService: data.years_of_service,
    isCurrent: data.is_current,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
    candidate: data.candidate ? candidateModel(data.candidate) : null,
});